import { render, staticRenderFns } from "./FundingPanel.vue?vue&type=template&id=5bfb15c8&scoped=true&"
import script from "./FundingPanel.vue?vue&type=script&lang=ts&"
export * from "./FundingPanel.vue?vue&type=script&lang=ts&"
import style0 from "./FundingPanel.vue?vue&type=style&index=0&id=5bfb15c8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb15c8",
  null
  
)

export default component.exports